<template>
  <div class="c-calendar-components">
    <Loader v-if="isLoading"/>
    <FullCalendar
        ref="fullCalendar"
        :options="calendarOptions"
    />
    <Modal v-if="showModal"/>
  </div>

</template>
<script>
import axios from 'axios'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import momentPlugin from '@fullcalendar/moment'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import {EventBus} from "../event-bus"
import Modal from "./Modal"
import Loader from "./Loader"
import VueScrollTo from "vue-scrollto"

export default {
  name: 'Calendar',
  props: {
    firstInstanceDate: {
      type: [String, Date],
      default: null
    },
    lastInstanceDate: {
      type: [String, Date],
      default: null
    }
  },
  components: {
    Modal,
    FullCalendar,
    Loader
  },
  data() {
    return {
      calendarOptions: {
        firstDay: 0,
        headerToolbar: this.setHeader(),
        dayMaxEventRows: true,
        views: this.setView(),
        footerToolbar: false,
        height: "auto",
        plugins: [dayGridPlugin, listPlugin, momentPlugin, momentTimezonePlugin],
        initialView: this.setDefaultView(),
        events: [],
        displayEventTime: false,
        eventContent: this.eventContent,
        listDayFormat: "ddd, MMMM D, YYYY",
        listDaySideFormat: false,
        validRange: this.validRange,
        fixedWeekCount: false,
        timeZone: "UTC",
        initialDate: moment.utc(this.firstInstanceDate).format('YYYY-MM-DD'),
        customButtons: {
          reset: {
            text: 'Show all dates',
            click() {
              window.location = window.location.origin + window.location.pathname + '#calendar'
            }
          }
        },
        buttonText: {
          month: 'GRID VIEW',
          list: 'LIST VIEW'
        },
        dayHeaderFormat: this.dayHeaderFormat(),
        rerenderDelay: 300,
        showNonCurrentDates: true,
        eventClick: this.eventClick,
        viewDidMount: this.viewDidMount,
      },
      showModal: false,
      isLoading: true,
      viewType: '',
      firstDate: this.firstInstanceDate,
      lastDate: this.lastInstanceDate,
      filterStartDate: this.setFilterStartDate(),
      filterEndDate: this.setFilterEndDate(),
      allInstances: {},
      events: [],
      currentDate: moment.utc(),
      calendarApi: null,
      currentView: 'dayGridMonth',
      scrollToOptions: {
        container: 'body',
        easing: 'ease-in',
        offset: -150,
        force: true,
        cancelable: true,
        x: false,
        y: true
      },
      timeout: null
    }
  },
  mounted() {

    this.calendarApi = this.$refs.fullCalendar.getApi()

    document.addEventListener('click', event => {
      if (event.target.matches('.fc-listTwoWeek-button')) {
        this.currentView = 'listTwoWeek'
        this.calendarApi.changeView('listTwoWeek')
        this.fetchInstances()
      }
      if (event.target.matches('.fc-dayGridMonth-button')) {
        this.currentView = 'dayGridMonth'
        this.calendarApi.changeView('dayGridMonth')
        this.fetchInstances()
      }
    });

    // Adds events to next and prev buttons to pull in instances on each click
    this.nextAndPreviousButtonAdditionalEvents()

    if (this.isFilteredView()) {
      this.fetchFilteredInstances(this.filterStartDate, this.filterEndDate)
    } else {
      this.fetchInstances()
    }
  },
  methods: {
    beforeRequest() {
      axios.interceptors.request.use((config) => {
        this.calendarOptions.events = []
        this.isLoading = true
        return config
      });
    },
    nextAndPreviousButtonAdditionalEvents() {
      const buttonSelectors = [
        ".fc-prev-button",
        ".fc-prev-button .fc-icon-chevron-left",
        ".fc-next-button",
        ".fc-next-button .fc-icon-chevron-right"
      ];

      buttonSelectors.forEach((selector) => {
        this.on("body", "click", selector, () => {
          this.fetchInstances();
        });
      });
    },

    addA11yHiddenTextToNavButtons() {
      const prevIcon = document.querySelector('.fc-prev-button .fc-icon');
      const nextIcon = document.querySelector('.fc-next-button .fc-icon');

      if (prevIcon && !prevIcon.querySelector('.u-hidden-visually')) {
        const hiddenText = document.createElement('span');
        hiddenText.classList.add('u-hidden-visually');
        hiddenText.textContent = 'Previous Month';
        prevIcon.appendChild(hiddenText);
      }

      if (nextIcon && !nextIcon.querySelector('.u-hidden-visually')) {
        const hiddenText = document.createElement('span');
        hiddenText.classList.add('u-hidden-visually');
        hiddenText.textContent = 'Next Month';
        nextIcon.appendChild(hiddenText);
      }
    },


    eventClick(info) {
      if (this.viewType === 'grid') {
        let date = moment.utc(info.event.start).format('YYYY-MM-DD')
        this.isLoading = true
        EventBus.$emit('calendar:open-modal', date)
      }
    },
    eventContent(arg) {
      // Fullcalendar didn't like Used to enabled the modal once the rendering has occurred to ensure the modal component is mounted which then allows the link
      // Otherwise Fullcalendar required a one click to show the component then another to show the modal
      this.showModal = true
      this.isLoading = false
      return {
        html: arg.event.title,
      };
    },
    fetchFilteredInstances(start, end) {
      this.beforeRequest()
      axios.get(window.ajax.url, {
        params: {
          action: 'basethemeCalendarRequest',
          start: start,
          end: end,
          viewType: this.viewType
        }
      }).then((response) => {
        if (window.location.hash === '#calendar') {
          VueScrollTo.scrollTo('#calendar', 300, this.scrollToOptions)
        }
        let responseInstances = response.data,
            instances = [];

        for (let i = 0; i < responseInstances.length; i++) {
          let instance = responseInstances[i];
          instances.push({
            title: instance.title,
            start: instance.start,
          });
        }

        // Assign the instances to our property as that is passed to the calendar
        this.calendarOptions.events = instances
        this.isLoading = false


      }).catch(function (error) {
        console.log(error)
        alert('There was error in fetching events')
      })
    },
    fetchInstances() {
      // Loads the instances for the month currently in view
      this.currentDate = moment.utc(this.calendarApi.currentData.viewApi.currentStart)
      let startDate = this.currentDate.format('YYYY-MM-DD'),
          endDate = null,
          currentMonth = this.currentDate.format('YYYY-MM')

      if (this.viewType === 'list') {
        endDate = this.currentDate.clone().add(13, 'days').format('YYYY-MM-DD')
      }
      const weekIndex = `${startDate}-${endDate}`

      // If the current month is a key inside the allInstances array, then load that, Otherwise, fetch the instances via ajax
      if (this.viewType === 'grid' && this.allInstances.hasOwnProperty(currentMonth)) {
        this.calendarOptions.events = this.allInstances[currentMonth]
      } else if (this.viewType === 'list' && this.allInstances.hasOwnProperty(weekIndex)) {
        this.calendarOptions.events = this.allInstances[weekIndex]
      } else {
        this.beforeRequest()
        axios.get(window.ajax.url, {
          params: {
            action: 'basethemeCalendarRequest',
            start: startDate,
            end: endDate,
            viewType: this.viewType
          }
        }).then((response) => {
          if (window.location.hash === '#calendar') {
            VueScrollTo.scrollTo('#calendar', 300, this.scrollToOptions)
          }
          let responseInstances = response.data,
              instances = [];

          for (let i = 0; i < responseInstances.length; i++) {
            let instance = responseInstances[i];
            instances.push({
              title: instance.title,
              start: instance.start,
            });
          }

          //Push our instances to the allInstances property, so we can use those next time rather than make another ajax call
          if (this.viewType === 'grid') {
            this.allInstances[currentMonth] = instances
          } else {
            this.allInstances[weekIndex] = instances
          }

          // Assign the instances to our property as that is passed to the calendar
          this.calendarOptions.events = instances
          this.isLoading = false
        })
        .catch(function (error) {
          console.log(error)
          alert('There was error in fetching events')
        })
      }
    },
    setDefaultView() {
      if (this.isFilteredView()) {
        return 'listFiltered'
      }

      return window.screen.width < 720 ? 'listTwoWeek' : 'dayGridMonth'
    },
    dayHeaderFormat() {
      return window.screen.width < 720 ? {weekday: 'short'} : {weekday: 'long'}
    },
    setFilterStartDate() {
      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has('startDate') && urlParams.get('startDate').length > 0) {
        return urlParams.get('startDate');
      }
    },
    setFilterEndDate() {
      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has('endDate') && urlParams.get('endDate').length > 0) {
        return urlParams.get('endDate');
      }
    },
    validRange(nowDate) {

      // Reduces to a list view when a date range has been searched applied via queryParams
      if (this.isFilteredView()) {
        const urlParams = new URLSearchParams(window.location.search)

        return {
          start: urlParams.get('startDate'),
          end: moment.utc(urlParams.get('endDate')).add(1, 'days').format('YYYY-MM-DD')
        }
      }

      if (this.firstInstanceDate && this.lastInstanceDate && this.currentView === 'listTwoWeek') {
        return {
          start: this.firstInstanceDate,
          end: moment.utc(this.lastInstanceDate).endOf('month').add(1, 'days').format('YYYY-MM-DD')
        }
      }

      if (this.calendarApi && this.calendarApi.currentData.viewApi.type === "dayGridMonth") {
        return {
          start: this.firstInstanceDate !== undefined ? this.firstInstanceDate : nowDate,
          end: this.lastInstanceDate !== undefined ? moment(this.lastInstanceDate).endOf('month').format("YYYY-MM-DD") : false,
        }
      }
    },
    viewDidMount(info) {
      let type = info.view.type,
          calendarWrapper = document.querySelector('.c-calendar-wrapper'),
          viewClass = 'c-' + type + '-view'

      calendarWrapper.classList.remove('c-dayGridMonth-view', 'c-listTwoWeek-view', 'c-listFiltered-view')
      calendarWrapper.classList.add(viewClass)


      if (type === 'dayGridMonth') {
        this.viewType = 'grid'
      } else {
        this.viewType = 'list'
      }

      // Add viusally hidden text to the next/prev spans for a11y/ARC happiness. 
      this.addA11yHiddenTextToNavButtons();

    },
    isFilteredView() {
      const urlParams = new URLSearchParams(window.location.search)

      return urlParams.has('startDate') && urlParams.get('startDate').length > 0
          && urlParams.has('endDate') && urlParams.get('endDate').length > 0
    },
    setHeader() {
      if (this.isFilteredView()) {
        return {
          left: 'reset',
          center: 'title',
          right: ''
        }
      }

      return {
        left: 'dayGridMonth,listTwoWeek',
        center: 'prev title next',
        right: ''
      }
    },
    setView() {
      if (this.isFilteredView()) {
        const urlParams = new URLSearchParams(window.location.search)
        let startDate = urlParams.get('startDate'),
            endDate = urlParams.get('endDate')

        const dateDifferenceInDays = Math.abs(moment.utc(startDate).diff(moment.utc(endDate).add('1', 'days'), 'days', true))

        return {
          'listFiltered': {
            type: 'listWeek',
            duration: {days: dateDifferenceInDays}
          }
        }
      }

      return {
        'listTwoWeek': {
          type: 'listWeek',
          duration: {days: 14}
        }
      }
    },
    on(selector, eventType, childSelector, eventHandler) {
      const elements = document.querySelectorAll(selector);
      for (let element of elements) {
        element.addEventListener(eventType, (eventOnElement) => {
          if (eventOnElement.target.matches(childSelector)) {
            eventHandler(eventOnElement);
          }
        });
      }
    },

  },
}
</script>
